import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bindMethods from 'auto-bind';

import { createHyperCubeDefForField, getQlikApp } from '../../../utils/qlik';
import { getQlikAppId } from '../../../state/selectors/getQlikAppId';
import { addTeamsData } from '../../../state/teams';
import { addTeam, removeTeam } from '../../../state/teamSeasonGameSelection';
import {
  selectTeam,
  clearTeamField,
  clearSeasonField,
  clearGamesField,
} from '../../../utils/qlikSelectValue';
import { FOOTBALL_TEAMS } from '../../../constants/fields';
import FilterItemPicker from './FilterItemPicker';
import { generateTeamOptions } from '../../../utils/generateTeamSeasonOptions';
import { getTeamValue } from '../../../state/selectors/getFilterValue';
import { reapplyDefaultSelections } from '../../../utils/defaultSelections';

class TeamFilter extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.hyperCubeDef = createHyperCubeDefForField(FOOTBALL_TEAMS);
  }

  async componentDidMount() {
    const {
      qlikAppId,
      teamSeasonGameSelection: { team, games },
      defaultSelections,
    } = this.props;

    if (qlikAppId) {
      if (team || games.length > 0) {
        return;
      }
      getQlikApp(qlikAppId).then((app) => {
        this.getTeamsData(app);
        if (FOOTBALL_TEAMS in defaultSelections) {
          this.applyDefaultTeam();
        }
      });
    }
  }

  async componentDidUpdate(prevProps) {
    const {
      qlikAppId,
      teamSeasonGameSelection: { team, games },
      defaultSelections,
    } = this.props;

    if (qlikAppId) {
      if (prevProps.qlikAppId !== qlikAppId) {
        getQlikApp(qlikAppId).then((app) => {
          this.getTeamsData(app);
        });
      }
      if (defaultSelections) {
        if (FOOTBALL_TEAMS in defaultSelections) {
          if (team || games.length > 0) {
            const defaultTeam = defaultSelections[FOOTBALL_TEAMS][0];
            if (team === defaultTeam) {
              return;
            }
          }
          this.applyDefaultTeam();
        }
      }
    }
  }

  async getTeamsData(app) {
    const { addTeamsData, defaultSelections } = this.props;
    clearTeamField(app);
    clearSeasonField(app);
    clearGamesField(app);

    reapplyDefaultSelections(app, defaultSelections);

    app.createCube(this.hyperCubeDef).then((results) => {
      // TypeError: Cannot read property 'layout' of undefined
      const teamList = results.layout.qHyperCube.qDataPages[0].qMatrix.map(x => x[0].qText);
      addTeamsData(teamList);
    });
  }

  applyDefaultTeam() {
    const { qlikAppId, addTeam, defaultSelections } = this.props;
    const defaultTeam = defaultSelections[FOOTBALL_TEAMS][0];

    getQlikApp(qlikAppId).then((app) => {
      this.getTeamsData(app);
    });
    addTeam(defaultTeam);
  }

  generateOptions() {
    const { teams } = this.props;
    const options = generateTeamOptions(teams.teams);
    return options;
  }

  handleChange(value) {
    const { addTeam, removeTeam, qlikAppId } = this.props;
    if (value) {
      getQlikApp(qlikAppId).then((app) => {
        selectTeam(app, [value.value]);
        addTeam(value.value);
      });
    } else {
      removeTeam();
      getQlikApp(qlikAppId).then((app) => {
        this.getTeamsData(app);
      });
    }
  }

  render() {
    const { teams, getTeamValue } = this.props;

    if (teams.isLoaded) {
      return (
        <FilterItemPicker
          id="Sidebar.Filters.Team"
          options={this.generateOptions()}
          value={getTeamValue}
          onChange={this.handleChange}
        />
      );
    }

    return null;
  }
}

TeamFilter.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
  addTeamsData: PropTypes.func.isRequired, // supplied from Redux
  teams: PropTypes.object.isRequired, // supplied from Redux
  teamSeasonGameSelection: PropTypes.object.isRequired, // supplied from Redux
  getTeamValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  addTeam: PropTypes.func.isRequired, // supplied from Redux
  removeTeam: PropTypes.func.isRequired, // supplied from Redux
  defaultSelections: PropTypes.object.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  getTeamValue: getTeamValue(state),
  teams: state.teams,
  teamSeasonGameSelection: state.teamSeasonGameSelection,
  defaultSelections: state.defaultSelections,
});

const mapDispatchToProps = { addTeamsData, addTeam, removeTeam };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TeamFilter);
